
export function isUndefinedOrEmpty<T>(value: T) {
  return value === undefined || value === '' || value === null || (typeof value === 'object' && Object.keys(value).length === 0);
}
